module.exports = __webpack_public_path__ + "static/media/wepark_cover.b0ff11d6.svg";